module.exports = __webpack_public_path__ + "img/line-bg.42e5379e.jpg";